import { ScrollToApplyButton } from '#/components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from '#/components/Breakpoint/DesktopOnly';
import { SaveListingButton } from '#/components/SaveButton/SaveListingButton';
import { ShareListingButton } from '#/components/ShareListingButton/ShareListingButton';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingActionsDropdown } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from '#/modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { ApiVolop } from '#/modules/listing/volops/api/types/ApiVolop';
import type { OrgDashboardApiVolop } from '#/modules/orgDashboard/api/listing/types/OrgDashboardApiVolop';

type Props = {
  volop: ApiVolop | OrgDashboardApiVolop;
  applied: boolean;

  // Save listing
  volopSaved: boolean;
  onSaveVolop: () => Promise<void>;
  onUnsaveVolop: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewVolopActionButtons({
  volop,
  applied,
  volopSaved,
  onSaveVolop,
  onUnsaveVolop,
  orgSaved,
  shouldShowSaveOrgTooltip,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  const { id, type, hasAts, url, org } = volop;
  const { i18n } = useI18n();

  return (
    <ListingViewActionButtons>
      <ScrollToApplyButton atsIsEnabled={hasAts} applied={applied}>
        {i18n('I Want to Help')}
      </ScrollToApplyButton>

      <SaveListingButton
        listingType={type}
        listingSaved={volopSaved}
        onSaveListing={onSaveVolop}
        onUnsaveListing={onUnsaveVolop}
        orgDetails={{
          onSaveOrg,
          onDismissSaveOrgTooltip,
          shouldShowSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType={type}
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={id}
        listingType={type}
        listingUrl={url}
        orgDetails={
          org
            ? {
                orgId: org.id,
                orgName: org.name,
                orgType: org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        markAsAppliedButton={null}
      />
    </ListingViewActionButtons>
  );
}
